import {Col, Form, Input, message, Radio, Row, Select} from "antd";
import {useEffect, useState} from "react";
import Validation from "../../../util/Validation";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {COMMON_DROPDOWN, DISTRICTS_LIST, IDENTIFICATION_SOURCE, PARAMETER_LIST} from "../../../util/Constants";
import {CustomerDto} from "../../../dto/CustomerDto";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import {MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";


interface ResidentialInformationProps {
    customerMstDto: CustomerDto
}

enum CORRSVALUES {
    YES = "PRIMARY",
    NO = "CORRESPONDENCE",
}

const ResidentialInformation = (props: ResidentialInformationProps) => {
    const [form] = Form.useForm();
    const [countryList, setCountryList] = useState<DropdownListDto[]>([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isSriLankaSelected, setSriLankaSelected] = useState(false);
    const [isCorsSriLankaSelected, setCorsSriLankaSelected] = useState(false);
    const [isPassport, setPassport] = useState(false);

    useEffect(() => {
        loadCountryList()
        setFormValue(props.customerMstDto);
    }, []);

    const loadCountryList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.COUNTRY,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setCountryList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setFormValue = (customerDto: CustomerDto) => {
        let addressList = undefined === customerDto.addressList ? [] : customerDto.addressList;
        checkCountry(addressList[0].countryName, CORRSVALUES.YES)
        setPassport(IDENTIFICATION_SOURCE.PP == customerDto.identificationSource?.sourceType)
        let formObj: any = {
            line1: addressList[0].line1,
            line2: addressList[0].line2,
            townOrCity: addressList[0].townOrCity,
            district: addressList[0].district,
            country: addressList[0].countryId,
            postalCode: addressList[0].postalCode,
            type: addressList[0].type,
            permanentAddressIdenticalToNicDl: addressList[0].permanentAddressIdenticalToNicDl
        }
        if (addressList?.length === 2) {
            formObj.corLine1 = addressList[1].line1;
            formObj.corLine2 = addressList[1].line2;
            formObj.corTownOrCity = addressList[1].townOrCity;
            formObj.corDistrict = addressList[1].district;
            formObj.corCountry = addressList[1].countryId;
            formObj.corPostalCode = addressList[1].postalCode;
            formObj.type = addressList[1].type;
            formObj.permanentAddressIdenticalToNicDl = addressList[1].permanentAddressIdenticalToNicDl

            setIsVisible(true)
            checkCountry(addressList[1].countryName, CORRSVALUES.NO)

        }
        formObj.faxNo = customerDto.faxNo;
        formObj.officePhoneNo = customerDto.officePhoneNo;
        formObj.homePhoneNo = customerDto.homePhoneNo;
        formObj.mobileNo = customerDto.mobileNo;
        formObj.email = customerDto.email;
        // formObj.mailingMethod = customerDto.mailingMethod;
        // setMailingMethod(customerDto.mailingMethod??'')
        form.setFieldsValue(formObj)


    }

    const checkCountry = (val: string | undefined, key: CORRSVALUES) => {
        if (undefined != val) {

            if ("sri lanka" === val.toLowerCase()) {
                CORRSVALUES.YES == key ? setSriLankaSelected(true) : setCorsSriLankaSelected(true)
            } else {
                CORRSVALUES.YES == key ? setSriLankaSelected(false) : setCorsSriLankaSelected(false)
            }
        }
    }

    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                form={form}
                disabled={true}
            >
                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <h4 className='account-create-form-subheader'>Permanent Address</h4>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Address Line 1"
                            name={"line1"}>
                            <Input placeholder="Enter address line 1"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Address Line 2"
                            name={"line2"}>
                            <Input placeholder="Enter address line 2"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Country"
                            name={"country"}>
                            <Select placement='bottomLeft' placeholder={"Select country"} listHeight={180}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={countryList}

                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="District"
                            name={"district"}
                        >
                            {isSriLankaSelected ?
                                <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input: any, option: {
                                            label: any;
                                        }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        options={DISTRICTS_LIST}
                                />
                                : <Input placeholder="Enter district"/>}
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Town/ City"
                            name={"townOrCity"}>
                            <Input placeholder="Enter town/city"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Zip Code"
                            name={"postalCode"}
                            onKeyPress={Validation.isNumberWithoutDot}>
                            <Input placeholder="Enter zip code"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        {!isPassport ? <Form.Item className='address_type_select'
                                    name={"permanentAddressIdenticalToNicDl"} style={{marginBottom: 5}}
                                    label={"Is the Permanent Address identical to the address on the NIC/Driver's License :"}>
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>: <></>}
                        <Form.Item className='address_type_select'
                                   name={"type"}
                                   label={"Is the Correspondence Address the same as Permanent Address :"}>
                            <Radio.Group>
                                <Radio value={CORRSVALUES.YES}>Yes</Radio>
                                <Radio value={CORRSVALUES.NO}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>

                {isVisible &&
                    (
                        <Row gutter={[32, 0]} style={{marginBottom: 8}}>
                            <Col span={24}>
                                <h4 className='account-create-form-subheader'>Correspondence Address</h4>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Address Line 1"
                                    name={"corLine1"}
                                >
                                    <Input placeholder="Enter address line1"/>
                                </Form.Item>
                            </Col>

                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Address Line 2"
                                    name={"corLine2"}>
                                    <Input placeholder="Enter address line2"/>
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Country"
                                    name={"corCountry"}>
                                    <Select placement='bottomLeft' placeholder={"Select country"} listHeight={180}
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input: any, option: {
                                                label: any;
                                            }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                            style={{width: '100%'}}
                                            options={countryList}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="District"
                                    name={"corDistrict"}>
                                    {isCorsSriLankaSelected ?
                                        <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                                getPopupContainer={(trigger: {
                                                    parentNode: any;
                                                }) => trigger.parentNode}
                                                style={{width: '100%'}}
                                                options={DISTRICTS_LIST}
                                        />
                                        :
                                        <Input placeholder="Enter district"/>}
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Town/City"
                                    name={"corTownOrCity"}>
                                    <Input placeholder="Enter town/city"/>
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Zip Code"
                                    name={"corPostalCode"}>
                                    <Input placeholder="Enter zip code"/>
                                </Form.Item>
                            </Col>
                        </Row>
                    )
                }


                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <h4 className='account-create-form-subheader'>Contact Details</h4>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Mobile Number"
                            name={"mobileNo"}>
                            <Input disabled placeholder="Enter mobile number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Fax"
                            name={"faxNo"}>
                            <Input placeholder="Enter fax number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Office Phone Number"
                            name={"officePhoneNo"}>
                            <Input placeholder="Enter office phone number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Residential Phone Number"
                            name={"homePhoneNo"}>
                            <Input placeholder="Enter residential phone number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item
                            label="Email"
                            name={"email"}>
                            <Input disabled placeholder="Enter email"/>
                        </Form.Item>
                    </Col>
                </Row>

            </Form>

        </div>
    )
}
export default ResidentialInformation